<template>
  <BaseModal modalColor="border-warning bg-warning" iconModal="fa fa-warning" subtitulo="Editar cliente"
             col-md="col-md-8" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="editarForm" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.personalidade"
                    inputId="personalidade"
                    :options="tipoPessoa"
                    optionLabel="label"
                    optionValue="value"
                    @change="alterarMascara"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('personalidade')"
                />
                <label for="personalidade">
                  <strong>Tipo Pessoa:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <InputGroup size="small">
                <FloatLabel variant="on">
                  <InputMask id="cpf_cnpj" v-model="dado.cpf_cnpj" size="small" style="width: 100%"
                             :mask="dado.personalidade === 'PF' ? '999.999.999-99' : '99.999.999/9999-99'"
                             :readonly="isCpfReadonly"
                             :invalid="campoVazio.includes('cpf_cnpj')"/>
                  <label for="cpf_cnpj"><strong>CPF/CNPJ: <span class="text-danger font-bold">*</span></strong></label>
                </FloatLabel>
                <InputGroupAddon>
                  <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="handleBlur"/>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="razao_social" v-model="dado.razao_social" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('razao_social')"/>
                <label for="razao_social"><strong>Nome Completo/Razão Social: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="fantasia" v-model="dado.fantasia" size="small" style="width: 100%"
                           :readonly="isFantasiaReadonly"/>
                <label for="fantasia"><strong>Nome Fantasia: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <InputGroup size="small">
                <FloatLabel variant="on">
                  <InputMask id="cep" v-model="dado.cep" size="small" style="width: 100%" mask="99999-999"
                             :invalid="campoVazio.includes('cep')"/>
                  <label for="cep"><strong>CEP: <span class="text-danger font-bold">*</span></strong></label>
                </FloatLabel>
                <InputGroupAddon>
                  <Button icon="pi pi-search" severity="secondary" variant="text" size="small" @click="cepClick"/>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>
          <div class="col-md-7">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="endereco" v-model="dado.endereco" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('endereco')"/>
                <label for="endereco"><strong>Endereço: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="numero" v-model="dado.numero" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('numero')"/>
                <label for="numero"><strong>Número: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="complemento" v-model="dado.complemento" size="small" style="width: 100%"/>
                <label for="complemento"><strong>Complemento: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="bairro" v-model="dado.bairro" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('bairro')"/>
                <label for="bairro"><strong>Bairro: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="cidade" v-model="dado.cidade" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('cidade')"/>
                <label for="cidade"><strong>Cidade: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="uf" v-model="dado.uf" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('uf')"/>
                <label for="uf"><strong>UF: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputMask id="telefone" v-model="dado.telefone" size="small" style="width: 100%"
                           mask="(99) 9.9999-9999" :invalid="campoVazio.includes('telefone')"/>
                <label for="telefone"><strong>Telefone: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputMask id="celular" v-model="dado.celular" size="small" style="width: 100%"
                           mask="(99) 9.9999-9999"/>
                <label for="celular"><strong>Celular: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_nascimento" v-model="dado.data_nascimento" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInput" dateFormat="dd/mm/yyyy"/>
                <label for="data_nascimento"><strong>Data Nascimento: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.sexo"
                    inputId="sexo"
                    :options="sexo"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('sexo')"
                />
                <label for="sexo">
                  <strong>Sexo:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="profissao" v-model="dado.profissao" size="small" style="width: 100%"/>
                <label for="profissao"><strong>Profissão: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="renda" v-model="dado.renda" size="small" style="width: 100%"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"
                             :invalid="campoVazio.includes('renda')"/>
                <label for="renda"><strong>Renda Bruta: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.nacionalidade"
                    inputId="nacionalidade"
                    :options="nacionalidade"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('nacionalidade')"
                />
                <label for="nacionalidade">
                  <strong>Nacionalidade:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.estado_civil"
                    inputId="estado_civil"
                    :options="estadoCivil"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    @change="atualizarEstadoCivil(dado.estado_civil)"
                    :invalid="campoVazio.includes('estado_civil')"
                />
                <label for="estado_civil">
                  <strong>Estado Civil:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <!-- Se casado-->
        <div id="id_conjuge_dados" class="row" v-if="mostrarConjuge">
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.tipo_uniao"
                    inputId="tipo_uniao"
                    :options="tipoUniao"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                />
                <label for="tipo_uniao">
                  <strong>Estado Civil:</strong>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="nome_conjuge" v-model="dado.nome_conjuge" size="small" style="width: 100%"/>
                <label for="nome_conjuge"><strong>Nome Cônjuge: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputMask id="cpf_conjuge" v-model="dado.cpf_conjuge" size="small" style="width: 100%"
                           mask="999.999.999-99"/>
                <label for="cpf_conjuge"><strong>CPF Cônjuge: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="renda_conjuge" v-model="dado.renda_conjuge" size="small" style="width: 100%"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="renda_conjuge"><strong>Renda Cônjuge: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="nome_mae" v-model="dado.nome_mae" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('nome_mae')"/>
                <label for="nome_mae"><strong>Nome Mãe: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="nome_pai" v-model="dado.nome_pai" size="small" style="width: 100%"/>
                <label for="nome_pai"><strong>Nome Pai: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_pessoal" type="email" v-model="dado.email_pessoal" size="small"
                           style="width: 100%"/>
                <label for="email_pessoal"><strong>E-mail Pessoal: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_financeiro" type="email" v-model="dado.email_financeiro" size="small"
                           style="width: 100%"/>
                <label for="email_financeiro"><strong>E-mail Financeiro: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="email_comercial" type="email" v-model="dado.email_comercial" size="small"
                           style="width: 100%"/>
                <label for="email_comercial"><strong>E-mail Comercial: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="status"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Status: <span class="text-danger font-bold">*</span></strong>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {alterar_mascara} from '@/../public/js/scripts/personalidade';
import {buscarCnpj} from '@/../public/js/api/buscar_cnpj';
import {buscarCep} from '../../../public/js/api/buscar_cep';
import {apiRequest, cpfValido, denormalizeDates, normalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";
import {toastMessage} from "@/utils/appInstance";

export default {
  name: "EditarCliente",
  components: {
    BaseModal,
  },
  props: {
    itemKey: String,
  },
  data() {
    return {
      mostrarConjuge: true,
      dado: 1,
      erro: null,
      isCpfReadonly: true,
      isFantasiaReadonly: true,
      campoVazio: [],
      status: [
        {label: 'ATIVO', value: 'A'},
        {label: 'INATIVO', value: 'I'}
      ],
      tipoPessoa: [
        {label: 'PESSOA FÍSICA', value: 'PF'},
        {label: 'PESSOA JURÍDICA', value: 'PJ'}
      ],
      sexo: [
        {label: 'FEMININO', value: 'F'},
        {label: 'MASCULINO', value: 'M'}
      ],
      nacionalidade: [
        {label: 'BRASILEIRO(A)', value: 'B'},
        {label: 'ESTRANGEIRO(A)', value: 'E'}
      ],
      estadoCivil: [
        {label: 'CASADO(A)', value: 'C'},
        {label: 'DIVORCIADO(A)', value: 'D'},
        {label: 'SOLTEIRO(A)', value: 'S'},
        {label: 'VIÚVO(A)', value: 'V'},
      ],
      tipoUniao: [
        {label: 'COMUNHÃO PARCIAL', value: 'P'},
        {label: 'COMUNHÃO UNIVERSAL', value: 'U'},
        {label: 'SEPARAÇÃO DE BENS', value: 'S'},
      ],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    atualizarEstadoCivil(estadoCivil) {
      if (estadoCivil === 'C') {
        this.mostrarConjuge = true;
      } else {
        this.mostrarConjuge = false;
      }
    },
    alterarMascara() {
      const {isCpfReadonly, isFantasiaReadonly} = alterar_mascara(this.dado.personalidade);
      this.isCpfReadonly = isCpfReadonly;
      this.isFantasiaReadonly = isFantasiaReadonly;
    },
    handleBlur() {
      if (this.dado.personalidade === 'PF') {
        this.checkCPF();
      } else {
        this.cnpjBlur();
      }
    },
    checkCPF() {
      if (!cpfValido(this.dado.cpf_cnpj)) {
        toastMessage("warn", "Atenção", "CPF inválido, Digite um CPF válido.");
      }
    },
    async cepClick() {
      await buscarCep(this.dado.cep, this.dado)
    },
    async cnpjBlur() {
      if (this.dado.personalidade === "PJ") {
        await buscarCnpj(this.dado.cpf_cnpj, this.dado)
      }
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.clientes.retrieveUpdateDestroy(this.itemKey)}?modo=edit`);
      if (resultado.success) {
        this.dado = resultado.data;
        if (this.dado.estado_civil === 'C') {
          this.mostrarConjuge = false;
          normalizeDates(this.dado, ['data_nascimento']);
        }
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      denormalizeDates(this.dado, ['data_nascimento']);
      const resultado = await apiRequest("PATCH", apiUrl.clientes.retrieveUpdateDestroy(this.itemKey), this.dado);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error)
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
    Inputmask("99/99/9999").mask(this.$refs.dataInput.$el.querySelector("input"));
  },
}
</script>
